import { FC } from "react";
import {
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
} from "@websential/cosmic-v20";
import { Box } from "@mui/material";

interface IConnectZohoInfoSetupFieldsPanel {
	connectZohoDDL: any;
}
export const ConnectZohoInfoSetupFieldsPanel: FC<
	IConnectZohoInfoSetupFieldsPanel
> = ({ connectZohoDDL }) => {
	return (
		<>
			<EnhancedDropDownRHFWithLabel
				label="Organization"
				selectName="organization"
				testId="Organization"
				labelPosition={LabelPosition.Top}
				items={connectZohoDDL ?? []}
				labelColumns={4}
				fieldColumns={8}
				showEmpty
			/>
		</>
	);
};
